module.exports = __webpack_public_path__ + "img/unfinished.43091273.png";